import { FileOutput, FileText, MessagesSquare, Scale } from 'lucide-react';
import { sonnatiTestimonial } from '@/content/testimonials';
import type { FeatureContent } from './types';

export const pareriEMemorandum: FeatureContent = {
  slug: 'pareri-e-memorandum',
  navLabel: 'Pareri e memorandum',
  menuDescription:
    'Trasforma un quesito in un parere o memorandum strutturato, documentato e pronto da rivedere e condividere.',
  cardDescription:
    'Trasforma l’analisi in un parere o memorandum strutturato, motivato e pronto da rivedere, adattare e condividere.',
  meta: {
    title: 'Pareri e memorandum con AI e fonti verificabili',
    description:
      'Trasforma un quesito del cliente in un parere argomentato o in un memorandum pronto da inviare, con norme, prassi e giurisprudenza citate per intero.',
  },
  hero: {
    title: 'Pareri e memorandum',
    subtitle:
      'Trasforma l’analisi in un parere o memorandum strutturato, motivato e pronto da rivedere, adattare e condividere.',
    image: {
      src: '/images/hero/hero-commercialisti.webp',
      alt: 'Trovanorma genera un memorandum su un quesito fiscale nel pannello accanto alla conversazione',
      width: 1600,
      height: 1008,
    },
  },
  statement: (
    <>
      Una risposta è utile
      <br />
      Un parere scritto resta
    </>
  ),
  statementText:
    'Trovanorma trasforma l’approfondimento in un documento ordinato, motivato e utilizzabile nel lavoro con clienti, colleghi e altri interlocutori.',
  blocks: [
    {
      icon: Scale,
      kicker: 'Parere argomentato',
      title: 'Dal quesito alla conclusione motivata',
      description:
        'Trovanorma organizza il quadro di riferimento, applica gli elementi rilevanti al caso e sviluppa una conclusione argomentata.',
    },
    {
      icon: FileText,
      kicker: 'Memorandum',
      title: 'Un’analisi già organizzata per essere letta',
      description:
        'Premessa, questioni da esaminare, quadro di riferimento, analisi e conclusioni in un documento strutturato.',
    },
    {
      icon: MessagesSquare,
      kicker: 'Registro e destinatario',
      title: 'La stessa analisi, nel registro giusto',
      description:
        'Parti dallo stesso lavoro per ottenere un approfondimento tecnico oppure una versione più sintetica e comprensibile da condividere con il destinatario.',
    },
    {
      icon: FileOutput,
      kicker: 'Revisione e condivisione',
      title: 'Lo rivedi, lo completi, lo condividi',
      description:
        'Modifica il documento, crea nuove versioni e continua a lavorarci in Word o PDF. I documenti generati possono essere modificati, salvati in nuove versioni ed esportati.',
    },
  ],
  steps: [
    {
      step: 1,
      title: 'Porta il quesito',
      description:
        'Descrivi il caso, il dubbio e gli elementi rilevanti. Aggiungi eventuali documenti di supporto.',
    },
    {
      step: 2,
      title: 'Trovanorma costruisce il documento',
      description:
        'Organizza l’analisi in un parere o memorandum strutturato, con i riferimenti rilevanti.',
    },
    {
      step: 3,
      title: 'Rivedi e condividi',
      description: 'Modifica il testo, adatta il registro ed esportalo nel formato che utilizzi.',
    },
  ],
  relatedSolutions: ['commercialisti', 'avvocati', 'consulenti-del-lavoro'],
  testimonial: sonnatiTestimonial,
  closing: {
    title: 'La consulenza non deve finire a voce',
    text: 'Porta un quesito reale e prova a trasformare l’analisi in un documento strutturato da rivedere e condividere.',
  },
};
